import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "post",
  makeRequestUrl: (host, params) => {
    return `${host}/maintenance/cud_maintenance_schedule?${params}`
  },
  checkRequiredArguments: (changeRequestData) => {
    if (changeRequestData === undefined)
      throw new Error("No change request data supplied.")
  },
  makeResponseData: (json) => {
    return json
  },
  returnRawResponse: true
}
export default createFetcher(fetcherConfiguration)
